module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_1536.77f03881.jpg";